import { versionCollections } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function VersionCollections() {
  return (
    <section id="collections" className="bg-background-50">
      <div className="px-4 py-12 md:px-6 md:py-16">
        <div className="mx-auto max-w-page">
          <SectionHeading
            index="03 / 版本合集"
            title="客户端按终端分册，装之前先对号入座"
            desc="安卓、iOS 与电脑版各自成册，每册都标注版本号与更新日期，装前先确认适配要求。"
          />

          <div className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-3">
            {versionCollections.map((item) => (
              <article
                key={item.id}
                className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:bg-background-100"
              >
                <div className="relative aspect-[9/7] w-full overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} - 91下载官方app下载入口`}
                    title={`${item.title} 91下载app下载`}
                    className="h-full w-full object-cover object-top"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs text-foreground-800">
                    {item.tag}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-center justify-between">
                    <h3 className="font-heading text-lg font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <span className="rounded-md bg-primary-100 px-2 py-0.5 font-label text-xs text-primary-700">
                      {item.ver}
                    </span>
                  </div>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {item.summary}
                  </p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                    <span className="text-xs text-foreground-500">{item.updated}</span>
                    <a
                      href="#guide"
                      className="inline-flex cursor-pointer items-center gap-1 whitespace-nowrap text-sm text-primary-700"
                    >
                      下载指引 <i className="ri-download-2-line" />
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}